import { Dispatch } from 'react'
import { AppState } from '../../store'
import * as api from '../services/api'
import { AccountInfo, PartnerResult, SubscriptionInfo } from './store'
import { ApiResponse } from '../../../modules/types'

import {
  RESET_SEARCH,
  SEARCH_ACCOUNTS_ERROR,
  SEARCH_ACCOUNTS_RECEIVED,
  SEARCH_ACCOUNTS_REQUEST,
  SEARCH_SUBSCRIPTIONS_ERROR,
  SEARCH_SUBSCRIPTIONS_RECEIVED,
  SEARCH_SUBSCRIPTIONS_REQUEST,
  SEARCH_TOGGLE_DEACTIVATED,
  SearchAction
} from './reducers'

export function toggleDeactivated(includeDeactivated: boolean) {
  return async function(state: AppState, dispatch: Dispatch<SearchAction>) {
    dispatch({
      type: SEARCH_TOGGLE_DEACTIVATED,
      deactivated: includeDeactivated
    })
  }
}

export function resetSearch() {
  return async function(state: AppState, dispatch: Dispatch<SearchAction>) {
    dispatch({
      type: RESET_SEARCH
    })
  }
}

export function getSubscriptionSearchResults(partnerIds: string[], text: string, includeDeactivated: boolean) {
  return async function (state: AppState, dispatch: Dispatch<SearchAction>) {
    try {
      dispatch({
        type: SEARCH_SUBSCRIPTIONS_REQUEST
      })

      const results = []

      for (const partnerId of partnerIds) {
        const partnerResults = await api.getSubscriptionSearchResults(partnerId,  text.trim(), includeDeactivated)

        const mappedResults: SubscriptionInfo[] = partnerResults.data.map((result: ApiResponse) => ({
          id: result.id,
          name: result.name,
          active: result.deactivated_at === null || result.deactivated_at === undefined,
          partnerId: result.reseller.data.id
        }))

        results.push({
          partnerId,
          results: mappedResults
        })
      }

      const requestTimeStamp = Date.now()
      const existingTimeStamp = state.search.subscriptions.timeStamp

      if (!existingTimeStamp || requestTimeStamp > existingTimeStamp) {
        dispatch({
          type: SEARCH_SUBSCRIPTIONS_RECEIVED,
          results,
          timeStamp: requestTimeStamp
        })
      }
    } catch (error) {
      dispatch({
        type: SEARCH_SUBSCRIPTIONS_ERROR
      })
    }
  }
}

export function getAccountSearchResults(partnerId: string, otherPartnerIds: string[], text: string, includeDeactivated: boolean) {
  return async function (state: AppState, dispatch: Dispatch<SearchAction>) {
    try {
      dispatch({
        type: SEARCH_ACCOUNTS_REQUEST
      })

      const requestTimeStamp = Date.now()

      const results = await api.getAccountSearchResults(partnerId,  text.trim(), includeDeactivated)

      const mappedResults: AccountInfo[] = results.data.map((result: ApiResponse) => ({
        id: result.id,
        name: result.name,
        isDemo: result.demo,
        active: result.deactivated_at === null || result.deactivated_at === undefined,
        subscriptionId: result.subscription.data.id,
        subscriptionName: result.subscription.data.name,
        subscriptionActive: result.subscription.data.deactivated_at === null
      }))

      const partnerResults: PartnerResult[] = []

      for (const pId of otherPartnerIds) {

        const partnerResult = await api.getAccountSearchResults(pId,  text.trim(), includeDeactivated)

        if (partnerResult.data.length > 0) {
          partnerResults.push({
            id: pId,
            count: partnerResult.data.length
          })
        }
      }

      const existingTimeStamp = state.search.accounts.timeStamp

      if (!existingTimeStamp || requestTimeStamp > existingTimeStamp) {
        dispatch({
          type: SEARCH_ACCOUNTS_RECEIVED,
          results: mappedResults,
          partnerResults,
          timeStamp: requestTimeStamp
        })
      }

    } catch (error) {
      dispatch({
        type: SEARCH_ACCOUNTS_ERROR
      })
    }
  }
}
